@for (item of statusList$ | async; track item) {
  <app-board-column
    [model]="item"
    [statusId]="item.id"
    [attr.statusId]="item.id"
    [ngClass]="{ board__column_hide: !isShowBacklog() && item.isBackLog }"
    class="board__column"
  >
  </app-board-column>
}

@if (isAdmin()) {
  <div class="board__add-status">
    <button type="button" class="board__create-btn" (click)="onCreateNewStatus()">
      <i class="icon-plus"></i>
    </button>
  </div>
}
